import React from "react";
import styles from "./index.module.less";
import {Button, Image} from "antd-mobile"
import { FC } from "react";
import { game_exceed_time } from "~src/assets/images/answerGame";
import classNames from "classnames";
import { useWXPath } from "~src/hooks/useWXPath";



const ExceedTime: FC = () => {
  const wxPath = useWXPath()
  return <div className={styles.exceed}>
    <Image className={styles.game_exceed_time} src={game_exceed_time}></Image>
    <div className={styles["exceed-footer"]}>
      <Button className={classNames(styles["exceed-btn"], styles["exceed-top"])} loading={false} disabled={false} loadingText='正在加载'
      onClick={() => {
        wxPath("navigateTo","/pages/duiba_v2/mall/index")
      }}
      >去福利汇看看</Button>
      <Button className={classNames(styles["exceed-btn"], styles["exceed-bottum"])} loading={false} disabled={false} loadingText='正在加载'
        onClick={() => {
          wxPath("switchTab","/pages/home/index")
        }}
      >去首页</Button>
    </div>
  </div>
}
export default ExceedTime